export default __webpack_public_path__ + "static/media/pac_recording.fdc4ade1.mp4";